import { Grid, Rating, Typography, Divider, Box } from "@mui/material";
import styles from "../../styles/proposal/reviewCard.module.css";

type ReviewItemType = {
  rating: number;
  note: string;
};
const ReviewDetailItem = (props: ReviewItemType) => {
  return (
    <>
      <Grid container className={styles.reviewItemGrid}>
        <Grid item container direction="row" alignItems="center">
          <Rating
            name="read-only"
            value={props.rating}
            precision={0.1}
            readOnly
          />
          <Box sx={{ ml: 2 }}>{props.rating.toFixed(1)}</Box>
        </Grid>
        <Typography variant="body2" className={styles.reviewText}>
          {props.note}
        </Typography>
      </Grid>
      <Divider />
    </>
  );
};

export default ReviewDetailItem;
